/**
 * Resolves a caught or queried error into a displayable message.
 *
 * The Tellescope SDK does not throw `Error` objects — `parseError` throws the raw response body
 * (usually a string, sometimes an object), so reading `.message` on an SDK error yields
 * `undefined`. Always route SDK errors through this rather than checking `instanceof Error`.
 */
export const resolveErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error === "string" && error.trim()) return error;
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
};
